<div class="empty-state">
  @if (icon()) {
    <outlaw-icon class="empty-state__icon" [name]="icon()" size="40px" />
  }
  @if (label()) {
    <div class="empty-state__label">{{ label() }}</div>
  }
</div>
